import React, { Fragment, useState } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import EndPoints from "src/Constants/EndPoints";
import CSS from "csstype";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

function GroupModal(props: any) {
  const { t, i18n } = useTranslation();
  const { user } = AppStateHandler.getState();
  const { refetch, showModal, setModalVisibility, groupData, setGroupData } = props;
  const {
    id,
    title,
    group_icon: icon = "/assets/images/placeholder@3x.png",
    is_private = false,
    description,
  } = groupData;
  const { errors, handleSubmit, register, reset } = useForm({
    defaultValues: {
      title: title,
      description: description,
      is_private: is_private
    },
    mode: 'onChange',
  });
  const [groupIcon, setGroupIcon] = useState<any>("");
  const [iconUrl, setIconUrl] = useState<any>(icon);

  const imgPreview: CSS.Properties = {
    width: "200px",
    height: "200px",
    padding: "10px",
    borderRadius: "50%",
  };
  const cameraIcon: CSS.Properties = {
    position: "absolute",
    top: "75%",
    right: "39%",
    fontSize: "24px",
    color: "darkslategray",
    cursor: "pointer",
  };

  const [createGroup, { status }] = useApiMutation({
    onSettled: (response) => {
      refetch();
      setModalVisibility(false);
      setGroupData([]);
    },
  });

  const handleCreateGroup = async (params: any) => {
    if (Object.keys(errors).length !== 0 || status === "loading") {
      return;
    }
    try {
      await createGroup({
        url: id ? EndPoints.updateGroup : EndPoints.createGroup,
        data: {
          groupId: id,
          subId: user?.username,
          group_icon: groupIcon,
          ...params,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fileSelectedHandler = async (imgs: any) => {
    const icon = imgs.length ? imgs[0] : null;
    if (icon) {
      try {
        const imgBase64 = await convertImagesToBase64(icon);
        setIconUrl(URL.createObjectURL(icon));
        setGroupIcon(imgBase64);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const convertImagesToBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        resolve(fileReader.result);
      };
      fileReader.onerror = function (error) {
        console.log("Error: ", error);
        reject(error);
      };
    });
  };

  const hideModal = (e: any) => {
    e.preventDefault();
    reset();
    setGroupData([]);
    setModalVisibility(false);
  };

  return (
    <Fragment>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="add_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="">
                <form onSubmit={handleSubmit(handleCreateGroup)}>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label className="mb-0">
                      {id ? t("Edit Group") : t("Create a Group")}
                    </label>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <div>
                      <div
                        style={{ position: "relative", textAlign: "center" }}
                      >
                        <img
                          style={imgPreview}
                          alt="London"
                          src={iconUrl && iconUrl !== "" ? iconUrl : "/assets/images/placeholder@3x.png"}
                        ></img>
                        <label htmlFor="photos">
                          <i
                            style={cameraIcon}
                            className="fa fa-camera"
                            aria-hidden="true"
                          ></i>
                        </label>
                        <input
                          id="photos"
                          className="d-none"
                          type="file"
                          accept="image/*"
                          onChange={(e) => fileSelectedHandler(e.target.files)}
                        />
                      </div>
                    </div>
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                      <label>{t("Title")}</label>
                      <input
                        name="title"
                        className="form-control"
                        placeholder={t("Your group title")}
                        ref={register({ required: "*"+t("Title is required") })}
                      />
                      {errors.title && (
                        <span className="ml-3 text-danger">
                          {errors.title.message}
                        </span>
                      )}
                    </div>
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                      <label>{t("Description")}</label>
                      <input
                        name="description"
                        className="form-control"
                        placeholder={t("Description")}
                        ref={register({ required: "*"+t("Description is required") })}
                      />
                      {errors.description && (
                        <span className="ml-3 text-danger">
                          {errors.description.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <input
                        id="is_private"
                        name="is_private"
                        type="checkbox"
                        ref={register()}
                      />
                      <label htmlFor="is_private" className={`mb-0 ${i18n.dir() === "rtl" ? "mr-2" : " ml-2"}`}>
                        {t("Private")}
                      </label>
                    </div>
                    <div className="d-flex">
                      <button
                        type="button"
                        className={`btn custom_btn border text-secondary bg-transparent fz14 ${i18n.dir() === 'rtl' ? 'ml-3' : 'mr-3'}`}
                        onClick={hideModal}
                      >
                        {t("Cancel")}
                      </button>
                      <button type="submit" className="btn custom_btn fz14">
                        <VisibilityToggle visible={status === "loading"}>
                          <span className="spinner-border spinner-border-sm"></span>
                        </VisibilityToggle>
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={() => setModalVisibility(false)}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default GroupModal;
